import type { ReactNode } from 'react';
import { CommunicationInputWrapper } from './CommunicationInputWrapper';

interface CommunicationDataFieldLayoutProps {
	isEditing: boolean;
	checkboxContent: ReactNode;
	editContent: ReactNode;
	valueContent: ReactNode;
	editButton: ReactNode;
	valueIndentClassName?: string;
}

export const CommunicationDataFieldLayout = ({
	isEditing,
	checkboxContent,
	editContent,
	valueContent,
	editButton,
	valueIndentClassName = 'ml-8',
}: CommunicationDataFieldLayoutProps) => (
	<CommunicationInputWrapper>
		{isEditing ? (
			<>
				<div className="flex flex-row gap-1">{checkboxContent}</div>
				{editContent}
			</>
		) : (
			<>
				<div className="flex w-full items-center justify-between gap-2 md:hidden">
					<div className="min-w-0 flex-1">
						<div className="flex flex-row gap-1">{checkboxContent}</div>
						<div className={valueIndentClassName}>{valueContent}</div>
					</div>
					<div className="flex items-center justify-center self-stretch">
						{editButton}
					</div>
				</div>

				<div className="hidden md:block">
					<div className="inline-flex items-center gap-1">
						<div className="flex flex-row gap-1">{checkboxContent}</div>
						{valueContent}
						<div className="flex items-center justify-center">{editButton}</div>
					</div>
				</div>
			</>
		)}
	</CommunicationInputWrapper>
);
